<template>
  <div class="reset-password">

    <v-container class="pa-3 pt-5">
      <template v-if="!confirm">
        <v-form class="px-3" ref="passwordForm">
          <!-- 新しいパスワード -->
          <v-text-field
            v-model="newPassword"
            prepend-icon="mdi-lock" 
            :rules="[rules.required, rules.password]"
            type="password"
            label="新しいパスワード"
            counter
          ></v-text-field>
          <!-- 新しいパスワード（確認） -->
          <v-text-field
            v-model="confirmPassword"
            prepend-icon="mdi-lock" 
            :rules="[rules.required, rules.password]"
            type="password"
            label="新しいパスワード（確認）"
            counter
          ></v-text-field>
        </v-form>
        <div>
          {{ passwordErrorMessage }}
        </div>
        <v-btn text color="primary" :loading="loading" @click="submit">
          パスワードをリセットする
        </v-btn>
      </template>
      <div v-else>
        <p class="my-3 text-body-2">パスワード変更が完了しました。</p>
        <p class="my-3 text-body-2">トップに戻ってログインしてください。</p>
        <v-btn @click="gotoTopClick">
          トップに戻る
        </v-btn>
      </div>
    </v-container>

  </div>
</template>

<script>
import { Put } from '../assets/request-api.js'

export default {
  data: () => ({
    confirm: false,
    loading: false,
    tm: null,
    newPassword: '',
    confirmPassword: '',
    rules: {
      required: value => !!value || '必須入力です',
      max: v => v.length <= 30 || '30文字以内で入力してください',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || '無効なメールアドレスです'
      },
      password: value => {
        const pattern = /^(?=.*?[a-z])(?=.*?\d)[a-z\d]{6,100}$/i
        return pattern.test(value) || '半角英数字をそれぞれ1種類以上含んだ6文字以上で入力してください'
      },
    },
    passwordErrorMessage: null,
  }),
  computed:{
  },
  methods:{
    async submit() {
      if (!this.$refs.passwordForm.validate()) {
        return
      }
      if (this.newPassword != this.confirmPassword) {
        this.passwordErrorMessage = '新しいパスワードが一致しません。'
        return
      }

      this.loading = true
      const url = '/verify/password'
      const params = {
        remember_token: this.$route.params.token,
        password: this.confirmPassword,
      }
      const result = await Put(url, params)

      if(RegExp(/^2[0-9]{2}$/u).test(result.statusCode)) {
        this.confirm = true
        this.tm = setTimeout(() => {
          this.$store.dispatch('error/clearError')
          window.location = '/'
        }, 10000);
      } 
      else {
        this.$store.dispatch('error/setError', { code: result.statusCode, id: result.requestId, message: result.response }, { root: true })
      }
      this.loading = false
    },
    gotoTopClick() {
      if (this.tm) {
        clearInterval(this.tm)
      }
      this.$store.dispatch('error/clearError')
      window.location = '/'
    },
  },
  async created(){
  },
}
</script>